import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { FindRelatedFilesRes } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const getAssociationFileColumns: ({
	tCapManage,
}: {
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>;
}) => ExtendedColumnDef<FindRelatedFilesRes>[] = ({ tCapManage }) => [
	createTextColumn({
		headerText: tCapManage('document.duplicate_deal_file_table.columns.file_name'),
		accessorKey: 'fileName',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createTextColumn({
		headerText: tCapManage('document.duplicate_deal_file_table.columns.classifier_name'),
		accessorKey: 'classifierName',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
];
